import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]

  static values = {
    updateUrl: String,
    currentType: String,
  }

  declare readonly dropdownTarget: HTMLSelectElement
  declare updateUrlValue: string
  declare currentTypeValue: string

  async change(event: Event) {
    const selected = (event.target as HTMLSelectElement).value
    const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')!.content

    if (selected === "") {
      await this.clearOverride(csrfToken)
    } else {
      await this.setOverride(selected, csrfToken)
    }
  }

  private async setOverride(accountType: string, csrfToken: string) {
    try {
      const response = await fetch(this.updateUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          Accept: "application/json",
        },
        body: JSON.stringify({ account_type_override: accountType }),
      })

      if (response.ok) {
        window.location.reload()
      } else {
        const data = await response.json()
        this.showError(data.errors ? data.errors.join(", ") : "Failed to set override")
        this.dropdownTarget.value = this.currentTypeValue
      }
    } catch (error) {
      this.showError("Failed to set override")
      this.dropdownTarget.value = this.currentTypeValue
    }
  }

  private async clearOverride(csrfToken: string) {
    try {
      const response = await fetch(this.updateUrlValue, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": csrfToken,
          Accept: "application/json",
        },
      })

      if (response.ok) {
        window.location.reload()
      } else {
        this.dropdownTarget.value = this.currentTypeValue
      }
    } catch (error) {
      this.showError("Failed to remove override")
      this.dropdownTarget.value = this.currentTypeValue
    }
  }

  private showError(message: string) {
    console.error(message)
    alert(message)
  }
}
